export default {
  welcomes: '欢迎来到后台，请选择左边其它菜单栏',
  rules: {
    username: '账号不能为空！',
    password: '密码不能为空！',
    code: '验证码不能为空！',
    form: {
      assist: '协助',
      system: '商户管理后台',
      Login: '登录',
      UserName: '请输入商户名',
      Password: '请输入登录密码',
      verification: '请输入谷歌验证码',
      Forgotpassword: '忘记秘密?',
      btnlogin: '登录',
      label: '简单，快捷，流畅',
      accountName: '账号名称',
      password: '密码',
      GoogleCode: '谷歌验证码'
    }
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/zh/login.js